import agentService from '../../../_services/agent.service';
import { DEMO_ON } from './demo';

/**
 * Pinned conversations.
 *
 * The server's word wins: once session rows carry `pinned`, that is the truth
 * and pinning calls POST /agent/sessions/:id/pin. Until then, on staging only,
 * pins are kept in this browser (with a copy of the row, so a pinned thread
 * still shows when it's older than the page of threads loaded) so the feature
 * can be demoed. On a build where neither is true, pinning isn't offered.
 */
const keyFor = () => {
    try { return `bly-pins:${(JSON.parse(localStorage.getItem('user')) || {})._id || ''}`; } catch (e) { return 'bly-pins:'; }
};

export const serverPins = (rows) => (rows || []).some((r) => typeof r.pinned === 'boolean');
export const canPin = (rows) => serverPins(rows) || DEMO_ON;

export function readLocalPins() {
    try {
        const list = JSON.parse(localStorage.getItem(keyFor()) || '[]');
        return Array.isArray(list) ? list.filter((r) => r && r._id) : [];
    } catch (e) { return []; }
}

function writeLocalPins(list) {
    try { localStorage.setItem(keyFor(), JSON.stringify(list)); } catch (e) { /* private mode: pins last the visit */ }
}

let pinMissing = false;

/** Pin or unpin. Resolves to the new local list (demo), or null (server). */
export async function setPinned(row, pinned, rows) {
    if (serverPins(rows)) {
        await agentService.pinSession(row._id, pinned);
        return null;
    }
    if (!pinMissing) {
        try {
            await agentService.pinSession(row._id, pinned);
        } catch (e) { pinMissing = true; /* not built yet: keep it in this browser */ }
    }
    const list = readLocalPins().filter((r) => String(r._id) !== String(row._id));
    const next = pinned
        ? [{ _id: row._id, title: row.title, summaryTitle: row.summaryTitle, lastMessageAt: row.lastMessageAt, createdAt: row.createdAt, pinnedAt: new Date().toISOString() }].concat(list)
        : list;
    writeLocalPins(next);
    return next;
}
